import {
  OriginEntitySectionsOriginSectionEntityInterface,
  SubmissionEntityInterface,
} from '@types';

export type SubmissionState = {
  submissions: SubmissionEntityInterface[];
  total: number;
  currentSubmission: SubmissionEntityInterface;
  currentSubmissionFormData: string;
  currentSubmissionInitialData: string;
  currentSubmissionInitialTitle: string;
  currentSubmissionInitialDescription: string;
  currentSubmissionMap: Record<string, unknown>;
  isCurrentSubmissionFailure: boolean;
  isCurrentSubmissionLoading: boolean;
  isCurrentSubmissionFormChanged: boolean;
  isCurrentSubmissionTitleChanged: boolean;
  isCurrentSubmissionSaved: boolean;
  isSubmissionCreateLoading: boolean;
  isSubmissionsDeleteLoading: boolean;
  isSubmissionUpdateLoading: boolean;
  isSubmissionDownloadLoading: boolean;
  isSubmissionDownloadFailure: boolean;
  isReassignSubmissionsGroupLoading: boolean;
  isReassignSubmissionsGroupFailure: boolean;
  isChangeSubmissionsTypeFailure: boolean;
  isChangeSubmissionsTypeLoading: boolean;
  isSubmissionCreateFailure: boolean;
  isSubmissionDeleteFailure: boolean;
  isSubmissionUpdateFailure: boolean;
  navigateToSubmission: string;
  checkedSubmissions: string[];
  isCurrentSubmissionTemplateEditorModeOn: boolean;
  isCurrentSubmissionTemplateEditorFormChanged: boolean;
  currentSubmissionDefaultOriginSections: OriginEntitySectionsOriginSectionEntityInterface[];
};

export const submissionInitialState: SubmissionState = {
  submissions: [],
  currentSubmission: null,
  currentSubmissionFormData: null,
  currentSubmissionInitialData: null,
  currentSubmissionInitialTitle: null,
  currentSubmissionInitialDescription: null,
  currentSubmissionMap: {},
  total: 0,
  isCurrentSubmissionFailure: false,
  isCurrentSubmissionLoading: false,
  isCurrentSubmissionFormChanged: false,
  isCurrentSubmissionTitleChanged: false,
  isCurrentSubmissionSaved: false,
  isSubmissionCreateLoading: false,
  isSubmissionsDeleteLoading: false,
  isSubmissionUpdateLoading: false,
  isSubmissionDownloadLoading: false,
  isSubmissionDownloadFailure: false,
  isSubmissionCreateFailure: false,
  isSubmissionDeleteFailure: false,
  isSubmissionUpdateFailure: false,
  isReassignSubmissionsGroupFailure: false,
  isReassignSubmissionsGroupLoading: false,
  isChangeSubmissionsTypeFailure: false,
  isChangeSubmissionsTypeLoading: false,
  navigateToSubmission: null,
  checkedSubmissions: [],
  isCurrentSubmissionTemplateEditorModeOn: false,
  isCurrentSubmissionTemplateEditorFormChanged: false,
  currentSubmissionDefaultOriginSections: [],
};
